import { IconName } from "#shared/icons/Icon";

type FileExtensionsToIcon = {
  [key: string]: IconName;
};

export const fileExtensionsToIcon: FileExtensionsToIcon = {
  pdf: "pdf",
  step: "step",
  stp: "step",
};
